(function () {
  const MOBILE_BP = 749;
  const isMobile = () => window.innerWidth <= MOBILE_BP;

  const sections = document.querySelectorAll('[data-hafa-sys-scroll]');
  if (!sections.length) return;

  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

  function updateSection(sec) {
    // Auf Mobile: color-Bild immer voll sichtbar, Labels bleiben versteckt (per CSS)
    if (isMobile()) {
      const colorImg = sec.querySelector('[data-color]');
      if (colorImg) colorImg.style.opacity = '1';
      return;
    }

    const rect = sec.getBoundingClientRect();
    const vh = window.innerHeight || 1;

    const total = rect.height - vh;
    const passed = -rect.top;
    const raw = total > 0 ? passed / total : 0;
    const p = clamp01(raw);

    const fadeEnd = parseFloat(getComputedStyle(sec).getPropertyValue('--fade-end')) || 0.55;
    const labelsStart = parseFloat(getComputedStyle(sec).getPropertyValue('--labels-start')) || 0.60;

    // image crossfade
    const colorImg = sec.querySelector('[data-color]');
    if (colorImg) {
      const t = clamp01(p / fadeEnd);
      colorImg.style.opacity = String(easeInOut(t));
    }

    // labels appear after labelsStart + per-label appear threshold
    const labels = sec.querySelectorAll('[data-appear]');
    labels.forEach((el) => {
      const appearAt = parseFloat(el.getAttribute('data-appear')) || 0.7;
      const threshold = Math.max(labelsStart, appearAt);
      const show = p >= threshold;
      el.style.opacity = show ? '1' : '0';
      el.style.transform = show ? 'translateY(0)' : 'translateY(6px)';
    });
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      sections.forEach(updateSection);
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();